export default {
  cake: {
    250: '0xE2463256E69E4C86345DC32e2FFED3283b0022e8',
    97: '',
  },
  masterChef: {
    250: '0xC8FF977ee4e5EdA2D650C0e2706995a1DbB4926b',
    97: '',
  },
  wbnb: {
    250: '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83',
    97: '',
  },
  lottery: {
    250: '',
    97: '',
  },
  lotteryNFT: {
    250: '',
    97: '',
  },
  mulltiCall: {
    250: '0xF18F19bEC92Ec6aa8aD6fA6496abC1B01Ec4590f',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    250: '0x8D11eC38a3EB5E956B052f67Da8Bdc9bef8Abf3E',
    97: '',
  },
  btcb: {
    250: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
    97: '',
  },
  eth: {
    250: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
    97: '',
  },
}
